export const getGraphConfig = () => {
  const textColor = '#495057';
  const textColorSecondary = '#6c757d';
  const surfaceBorder = '#dfe7ef';
  let stackedOptions = {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      tooltip: {
        mode: 'index',
        intersect: false,
      },
      legend: {
        position: 'bottom',
        labels: {
          fontColor: textColor
        }
      }
    },
    scales: {
      x: {
        stacked: true,
         ticks: {
            autoSkip: false,   // Show all labels, regardless of their length
            maxRotation: 60,   // Rotate labels to 60 degrees
            minRotation: 60,    // Keep consistent rotation angle
            callback: function(value) {
              const label = this.getLabelForValue(value);
              return label.length > 20 
                  ? label.slice(0, 20) +'...'
                  : label;
          }
        },
        grid: {
          display: false
        }
      },
      y: {
        min: -1000, 
        max: 1000,
        stacked: true,
        ticks: {
          color: textColorSecondary
        },
         border: {
              dash: [5, 6],
          },
        grid: {
          color: surfaceBorder
        }
      }
    }
  };
  return {
    stackedOptions,
  };
};
export const alertTypes = {
  "maxBet" : "Max Bet Alert",
  "suddenSpike" : "Sudden Spike Alert"
}
export const alertTypeIcons = {
  "maxBet" : "pi pi-exclamation-circle",
  "suddenSpike" : "pi pi-chart-line"
}

export const alertHistoryData = [
  {
    type: "Stake exceeded threshold",
    id: "31981403",
    event: "Los Angeles Lakers vs. Boston Celtics",
    netGGR: "0.00",
    status: "Won",
    location: "Washington",
    desciption: "Threshold breach $50,000 (Normal Avg: $10,000)",
  },
  {
    type: "Unusual betting pattern",
    id: "31981404",
    event: "Los Angeles Lakers vs. Boston Celtics",
    netGGR: "0.00",
    status: "Lost",
    location: "Washington",
    desciption: "Threshold breach $50,000 (Normal Avg: $10,000)",
  },
  {
    type: "Stake exceeded threshold",
    id: "31981405",
    event: "Los Angeles Lakers vs. Boston Celtics",
    netGGR: "0.00",
    status: "Won",
    location: "Washington",
    desciption: "Threshold breach $50,000 (Normal Avg: $10,000)",
  },
  {
    type: "Unusual betting pattern",
    id: "31981406",
    event: "Los Angeles Lakers vs. Boston Celtics",
    netGGR: "0.00",
    status: "Lost",
    location: "Washington",
    desciption: "Threshold breach $50,000 (Normal Avg: $10,000)",
  },
  {
    type: "Stake exceeded threshold",
    id: "31981407",
    event: "Los Angeles Lakers vs. Boston Celtics",
    netGGR: "0.00",
    status: "Won",
    location: "Washington",
    desciption: "Threshold breach $50,000 (Normal Avg: $10,000)",
  },
  {
    type: "Unusual betting pattern",
    id: "31981408",
    event: "Los Angeles Lakers vs. Boston Celtics",
    netGGR: "0.00",
    status: "Lost",
    location: "Washington",
    desciption: "Threshold breach $50,000 (Normal Avg: $10,000)",
  },
  {
    type: "Stake exceeded threshold",
    id: "31981409",
    event: "Los Angeles Lakers vs. Boston Celtics",
    netGGR: "0.00",
    status: "Won",
    location: "Washington",
    desciption: "Threshold breach $50,000 (Normal Avg: $10,000)",
  },
  {
    type: "Unusual betting pattern",
    id: "31981410",
    event: "Los Angeles Lakers vs. Boston Celtics",
    netGGR: "0.00",
    status: "Lost",
    location: "Washington",
    desciption: "Threshold breach $50,000 (Normal Avg: $10,000)",
  },
];
export const maxDate = (() => {
  const nowUTC = new Date(new Date().toUTCString());
  const hourUTC = nowUTC.getUTCHours();
  const offsetDays = hourUTC >= 21 ? 1 : 2;

  const resultDate = new Date();
  resultDate.setUTCDate(nowUTC.getUTCDate() - offsetDays);

  // Optional: strip time for safety (sets time to 00:00:00)
  resultDate.setUTCHours(0, 0, 0, 0);

  return resultDate;
})();
